<ng-container *transloco="let t">
  <span aria-hidden="true" class="fixed-space-24"></span>
  <ng-container *ngIf="!hideTitle">
    <h3 class="title">{{ t('rate_your_experience') }}</h3>
    <span class="fixed-space-8" aria-hidden="true"></span>
  </ng-container>
  <app-ratings
    [mode]="'interactive'"
    [rating]="rating"
    [showIfEmpty]="true"
    [showStarsCount]="false"
    [condensed]="true"
    (ratingChange)="onRatingChange($event)"></app-ratings>
  <ng-container *ngIf="showFeedbackButton">
    <span class="fixed-space-24" aria-hidden="true"></span>
    <button
      class="button popsy-button-secondary feedback-button"
      [attr.aria-label]="t('action_help_us_improve')"
      (click)="onShowFeedback()">
      {{ t('action_help_us_improve') }}
    </button>
  </ng-container>
  <ng-container *ngIf="showRateUsButton">
    <span class="fixed-space-24" aria-hidden="true"></span>
    <button
      class="button popsy-button-secondary feedback-button"
      (click)="onRatingClicked()">
      {{ t('action_rate_us') }}
    </button>
  </ng-container>
  <span aria-hidden="true" class="fixed-space-24"></span>
</ng-container>
